var _ellipse, _path, _path2, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAircraftActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3359,
    cy: 27.6,
    rx: 21.5468,
    ry: 21.6,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.345 19.6001L29.1283 15.6001L41.0987 36.8001L7.98047 28.0001L18.3549 21.6001L30.7243 30.8001",
    stroke: "#F2D861",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.968 27.1999C52.968 41.7262 41.2215 53.4999 26.734 53.4999C12.2465 53.4999 0.5 41.7262 0.5 27.1999C0.5 12.6736 12.2465 0.899902 26.734 0.899902C41.2215 0.899902 52.968 12.6736 52.968 27.1999Z",
    stroke: "#F2D861"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.98118,
    cy: 9.2,
    rx: 3.19212,
    ry: 3.2,
    fill: "#F2D861"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4968,
    cy: 49.2,
    rx: 3.19212,
    ry: 3.2,
    fill: "#F2D861"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraftActive);
export default __webpack_public_path__ + "static/media/aircraft-active.daf9cab746ffee2eb57e9a8d8b3dd2ba.svg";
export { ForwardRef as ReactComponent };